export default __webpack_public_path__ + "static/media/engagement3.f425686a.png";